// Angular import
import { Component, output, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { addCollection } from '@iconify/iconify';
import * as solarIcons from '@iconify-json/solar/icons.json';

// project import

import { NavContentComponent } from './nav-content/nav-content.component';

@Component({
  standalone: true,
  selector: 'app-navigation',
  imports: [NavContentComponent, CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent {
  // media 1025 After Use Menu Open
  NavCollapsedMob = output();

  navCollapsedMob;
  windowWidth: number;

  // Constructor
  constructor() {
    this.windowWidth = window.innerWidth;
    this.navCollapsedMob = false;
    
    // Initialize Solar icons
    addCollection(solarIcons as any);
  }

  // public method
  navCollapseMob() {
    if (this.windowWidth < 1025) {
      this.NavCollapsedMob.emit();
    }
  }
}
